import React, { useEffect, useState } from 'react';
import styles from './AdminVideos.module.css';
import { c7Api } from '../../../Logic/c7Api';
import { authCursoLogic, ClaseData } from '../../../Logic/AuthCurso';

const AdminVideos = () => {
  const [formData, setFormData] = useState({ title: '', videoid: '' });
  const [pdfFile, setPdfFile] = useState<File | null>(null); // Nuevo: estado para el archivo
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState("");
  const [allClasses, setAllClasses] = useState<ClaseData[]>([]);
  
  const token = localStorage.getItem("token");

  // Función para refrescar la lista
  const fetchClasses = async () => {
    try {
      const data = await authCursoLogic.GetAllClassesCurso();
      setAllClasses(data);
    } catch (err) {
      console.error("Error cargando clases", err);
    }
  };

  useEffect(() => {
    fetchClasses();
  }, [loading]);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setLoading(true);

    // Usamos FormData para soportar el envío del archivo PDF
    const data = new FormData();
    data.append('title', formData.title);
    data.append('videoid', formData.videoid);

    if (pdfFile) {
      data.append('pdf', pdfFile); // El nombre 'pdf' debe coincidir con el backend
    }

    try {
      const response = await fetch(c7Api.getBaseUrl() + '/api/admin/videos', {
        method: 'POST',
        headers: { 
          // IMPORTANTE: NO incluir 'Content-Type', el navegador lo pone auto con el boundary
          'Authorization': `Bearer ${token}`, 
          'Accept': 'application/json'
        },
        body: data, 
      });

      if (response.ok) {
        setSuccess("¡Lección y material guardados con éxito!");
        setFormData({ title: '', videoid: '' });
        setPdfFile(null); // Limpiar el input de archivo
        
        // Resetear el input file visualmente
        const fileInput = document.getElementById('pdfInput') as HTMLInputElement;
        if (fileInput) fileInput.value = "";

      } else {
        setError("Error al guardar la lección");
      }
    } catch (error: any) {
      setError(error.toString());
    } finally {
      setLoading(false);
      setTimeout(() => setError(""), 3000);
      setTimeout(() => setSuccess(""), 3000);
    }
  };

  return (
    <div>
      <div className={styles.adminContainer}>
        <form onSubmit={handleSubmit} className={styles.videoForm}>
          <div className={styles.inputGroup}>
            <label>Título de la Lección</label>
            <input 
              type="text" 
              placeholder="Ej: Semana 1: Introducción"
              value={formData.title}
              onChange={(e) => setFormData({...formData, title: e.target.value})}
              required 
            />
          </div>
          
          <div className={styles.inputGroup}>
            <label>ID de Video (Vimeo)</label>
            <input 
              type="text" 
              placeholder="Ej: 1153727413"
              value={formData.videoid}
              onChange={(e) => setFormData({...formData, videoid: e.target.value})}
              required 
            />
          </div>

          <div className={styles.inputGroup}>
            <label>Material Complementario (PDF)</label>
            <input 
              id="pdfInput"
              type="file" 
              accept=".pdf"
              onChange={(e) => setPdfFile(e.target.files ? e.target.files[0] : null)}
              required
            />
          </div>

          <button type="submit" disabled={loading} className={styles.saveButton}>
            {loading ? 'Guardando...' : 'Publicar Lección'}
          </button>
          
          <div>{error && <p className={styles.error}>{error}</p>}</div>
          <div>{success && <p className={styles.success}>{success}</p>}</div>
        </form>
      </div>

      <div className={styles.tableContainer}>
        <table className={styles.table}>
          <thead>
            <tr>
              <th>Título Lección</th>
              <th>Vimeo ID</th>
              <th>Material</th>
            </tr>
          </thead>
          <tbody>
            {allClasses.map((c: ClaseData, index) => (
              <tr key={index}>
                <td>{c.title.toUpperCase()}</td>
                <td>{c.youtubeid}</td>
                <td>
                  {/* Server/ -> es para que haga match con la ruta de hostinger*/}
                  {c.pdfName ? (
                    <a href={c7Api.getBaseUrl() + ( c7Api.getBaseUrl().includes("127.0.0.1") ? c.pdfName : "/Server/public" + c.pdfName)} target="_blank" rel="noreferrer" className={styles.link}>
                      📄 Ver PDF
                    </a>
                  ) : (
                    <span style={{ opacity: 0.5 }}>Sin PDF</span>
                  )}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default AdminVideos;